module.exports = __webpack_public_path__ + "img/xs.f3935bf0.png";